module.exports = __webpack_public_path__ + "img/downloadLogo.d0fb38f0.svg";